import React, { useState } from "react";
import InputField from "../Components/InputField";
import { useNavigate } from "react-router-dom";
import axios from "../shared";
import AlertField from "../Components/AlertField";

const ResetPassword = () => {
  const [values, setValues] = useState({
    email: "",
  });
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const inputs = [
    {
      id: 1,
      name: "email",
      type: "email",
      placeholder: "Enter email",
      errorMessage: "Enter a valid email address!",
      label: "Email",
      required: true,
    },
  ];

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("auth/password/reset/", JSON.stringify(values));
      showAlert(
        "Password reset link has been sent to your mail. Check your mail.",
        "success"
      );
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 400) {
        showAlert("Enter your email.", "warning");
      } else if (err.response?.status === 404) {
        showAlert("Account with the given email not found.", "warning");
      } else {
        showAlert("Process Failed", "warning");
      }
    }
  };

  async function cancel() {
    navigate("/login");
  }

  return (
    <div>
      <AlertField alert={alert} />

      <div className="d-flex justify-content-center mt-5">
        <div className="p-5 bg-light border rounded-3">
          <h1 className="text-center pb-3">Reset Password</h1>
          <h6>
            Enter you email address so that we can send password reset link to
            you.
          </h6>

          <form onSubmit={handleSubmit}>
            {inputs.map((input) => (
              <InputField
                key={input.id}
                {...input}
                value={values[input.name]}
                onChange={onChange}
              />
            ))}
            <div className="text-center mt-2">
              <button
                className="btn btn-outline-danger m-2 py-2 px-5"
                onClick={cancel}
                type="button"
              >
                Cancel
              </button>
              <button className="btn btn-outline-dark m-2 py-2 px-5">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
